<app-card>
  <div class="flex gap-4">
    <div class="w-1/3">
      <div class="bg-gray-100 dark:bg-dark-hover py-2 px-3 rounded-md">
        {{ 'vee.details.title' | translate }}
      </div>
      <app-value-details
        [collection]="veeCollection"
        [data]="vee"
      ></app-value-details>
    </div>

    <div class="w-2/3 flex flex-col gap-4">
      <div class="bg-gray-100 dark:bg-dark-hover py-2 px-3 rounded-md">
        {{ 'vee.details.estimationMethods' | translate }}
      </div>

      <app-table
        [config]="veeTableConfig"
        [data]="veeTableData"
      ></app-table>
    </div>
  </div>
</app-card>
